import { Component, OnInit, Input } from '@angular/core';
import { Router } from "@angular/router";
import { environment } from '../../../environments/environment';
import { AppConfig } from "../webapi/faceted-search-app.model";
import { FacetedSearchAppService } from "../webapi/faceted-search-app.service";
import { CurrentUser } from '../../security/current-user.model';
import { CurrentUserService } from "../../security/current-user.service";
import { PresetSaveDialogComponent } from "../preset-save-dialog/preset-save-dialog.component";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material'

@Component({
  selector: 'faceted-search-app-banner',
  templateUrl: './faceted-search-app-banner.component.html',
  styleUrls: ['./faceted-search-app-banner.component.css']
})

export class FacetedSearchAppBannerComponent implements OnInit {

  config: AppConfig;

  constructor(private facetedSearchAppService: FacetedSearchAppService, private currentUserService: CurrentUserService, public presetSaveDialog: MatDialog) {
  }

  savePresetDialog() {
    let dialogRef = this.presetSaveDialog.open(PresetSaveDialogComponent);
    console.log(dialogRef);
  }

  ngOnInit(): void {
    this.facetedSearchAppService.getAppConfig().then(x => {
      this.config = x;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/fsapplication/faceted-search-app-banner/faceted-search-app-banner.component.ts